.day:hover {
    filter: brightness(0.85);
    cursor: pointer;
}
